import { createListPreviewPanel } from 'presentation/screens/ListBuilderScreen/components/ListPreviewPanel/ListPreviewPanel'
import { PropertiesListItemCard } from 'presentation/screens/ListBuilderScreen/components/PropertiesListPreviewPanel/components/PropertiesListItemCard'

export const PropertiesListPreviewPanel = createListPreviewPanel({
  componentPrefix: 'Properties',
  ItemComponent: PropertiesListItemCard,
  title: 'Properties',
})
